export function priceDecimals(value) {
    const abs = Math.abs(Number(value));

    return abs >= 1000 ? 0 :
        abs >= 100 ? 1 :
        abs >= 10 ? 2 :
        abs >= 1 ? 3 : 4;
}

// The grid formatNumber snaps to at this magnitude.
// 1 / 10**d, never Math.pow(10, -d) — that gives 0.0000999999... and breaks equality.
export function priceStep(value) {
    return 1 / Math.pow(10, priceDecimals(value));
}

export function formatNumber(value) {
    const num = Number(value);

    if (!isFinite(num)) return 0; // handles NaN, null, undefined, Infinity

    if (num === 0) return 0;

    // Round up, but strip floating-point noise first so exact values
    // like 76.4 don't get bumped to 76.41 (76.4 * 100 = 7640.000...001).
    const multiplier = Math.pow(10, priceDecimals(num));
    const scaled = Math.round(num * multiplier * 1e8) / 1e8;
    const rounded = Math.ceil(scaled) / multiplier;

    return rounded;
}

// Drops the trailing zeros a fixed decimal count leaves behind: 1.20 -> 1.2, 1.00 -> 1
function trimDecimals(value) {
    return value.replace(/\.?0+$/, '');
}

export function shortNumber(no) {
    const num = Number(no);
    if (!isFinite(num) || num === 0) return 0;

    const abs = Math.abs(num);
    const sign = num < 0 ? '-' : '';

    // Pick the tier from the rounded value, so 999,999 reads 1M and not 1000K.
    const thousands = Number((abs / 1000).toFixed(1));

    if (thousands >= 1000) {
        return sign + trimDecimals((abs / 1000000).toFixed(2)) + 'M';
    }

    if (abs >= 10000) {
        return sign + trimDecimals(thousands.toFixed(1)) + 'K';
    }

    return sign + new Intl.NumberFormat('en-US').format(formatNumber(abs));
}

export default {
    data() {
        return {
            monthName: [
                'Jan',
                'Feb',
                'Mar',
                'Apr',
                'May',
                'Jun',
                'Jul',
                'Aug',
                'Sep',
                'Oct',
                'Nov',
                'Dec',
            ],
        }
    },
    methods: {
        getDistance(open_price, current_price) {
            let distance = Math.round((current_price / open_price - 1) * 1000) / 10;
            
            return {
                value: distance,
                formatted: (distance > 0 ? '+'+distance: ''+distance) +'%'
            }
        },
        formatNumber(value) {
            return formatNumber(value);
        },
        shortNumber(no) {
            return shortNumber(no);
        },
        priceStep(value) {
            return priceStep(value);
        },
        formatPrice(price, short = false) {
            if (typeof price === 'string') {
                price = parseFloat(price);
            }

            if (short) {
                return this.shortNumber(price);
            }

            // crypto prices can be fractions of a cent; keep them raw
            if (price <= 0.1) return price;

            var no = new Intl.NumberFormat('en-US');
            return no.format(this.formatNumber(price));
        },
        formatAmount(value) {
            return '$' + this.formatPrice(value);
        },
        formatHoldings(holdingsNumber) {
            return this.shortNumber(holdingsNumber);
        },
        sumHoldings(balances, bucketType) {
            let holdings = 0

            if ( ! ['trading', 'long'].includes(bucketType)) {
                bucketType = undefined;
            }

            for (let i=0; i < balances.length; i++) {
                if (bucketType && balances[i].bucket.type !== bucketType) {
                    continue;
                }
                
                holdings += balances[i].shares
            }

            return holdings
        },
        formatTime(dateObject) {
			const now = new Date();
            const daysDiff = (now - dateObject) / (1000 * 3600 * 24);

            if (daysDiff < 0.5 || dateObject.toISOString().split('T')[0] === now.toISOString().split('T')[0]) {
                let time = dateObject.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
                return time.toLowerCase();
            } else {
                let dateString = this.monthName[dateObject.getMonth()] + ' ' + dateObject.getDate()
                if (now.getFullYear() === dateObject.getFullYear()) {
                    return dateString
                }
                else {
                    return dateString + ', ' + dateObject.getFullYear()
                }
            }

        },
        dateFromISO(timeString) {
            if (timeString.includes('+')) timeString = timeString.split('+')[0]+'Z';
            if (!timeString.includes('Z')) timeString = timeString+'Z';

            return new Date(timeString);

        },
        formatTimeFromISO(timeString) {
            return this.formatTime(this.dateFromISO(timeString));
        },
        rowClass(rowIndex) {
            if (rowIndex % 2) return 'oddRow';

            return 'evenRow'
        }
    }
}